import { useEffect, useRef, useState } from "react";
import { home } from "../content/home";
import { useContent } from "../ui/helpers";
import { createPlatformModel } from "./platformModelEngine";

export function PlatformModel() {
  const c = useContent(home).model;
  const canvasRef = useRef(null);
  const stageRef = useRef(null);
  const engine = useRef(null);
  const [active, setActive] = useState(0);

  useEffect(() => {
    engine.current = createPlatformModel(canvasRef.current, stageRef.current, { text: c.canvasText, onAutoLayer: setActive });
    return () => engine.current?.destroy();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => { engine.current?.setText(c.canvasText); }, [c.canvasText]);

  const pick = (id) => { setActive(id); engine.current?.setActive(id, true); };

  return (
    <section className="model" id="model">
      <div className="k-wrap">
        <div className="sec-head model-head rv">
          <div>
            <p className="k-label">{c.eyebrow}</p>
            <h2 className="h-sec" style={{ marginTop: 16 }}>{c.title}</h2>
          </div>
          <p className="model-intro">{c.intro}</p>
        </div>
      </div>
      <div className="k-wrap model-grid">
        <div className="rv">
          <ul className="layers">
            {c.layers.map((l) => (
              <li key={l.id} className={active === l.id ? "on" : undefined}>
                <button type="button" onClick={() => pick(l.id)} onMouseEnter={() => pick(l.id)} onFocus={() => pick(l.id)}>
                  <b>{l.tag}</b>
                  <span><strong>{l.title}</strong><span><em>{l.body}</em></span></span>
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="stage" ref={stageRef}>
          <canvas ref={canvasRef} role="img" aria-label={c.canvasLabel} />
          <div className="stage-hint"><span>{c.signal}</span>{c.hint}</div>
        </div>
      </div>
    </section>
  );
}
